import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import styles from "./TopFooterHealthBanner.module.scss";
const { sanitize } = dompurify;
export const TopFooterHealthBanner = ({ content, font, fontColor, backgroundColor, bordersColor, bordersSize, isDefaultFont, fontSize, fontSizePercent, isRounded, }) => {
    const rootStyle = {
        backgroundColor,
    };
    const style = {
        color: fontColor,
        fontFamily: font,
        fontSize: isDefaultFont ? `${fontSize}px` : `${fontSizePercent}%`,
        border: `${bordersSize}px solid ${bordersColor}`,
    };
    const currentClassName = classNames(styles.HealthBannerContent, {
        [styles.rounded]: isRounded,
    });
    return (_jsx("div", { "data-testid": "top-footer-health-banner-wrapper", className: styles.HealthBannerContainer, style: rootStyle, children: _jsx("div", { className: currentClassName, style: style, children: content && (_jsx("p", { className: styles.message, dangerouslySetInnerHTML: {
                    __html: sanitize(content),
                } })) }) }));
};
//# sourceMappingURL=TopFooterHealthBanner.js.map